import { Sparkles } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AiWritingAssistantDialog from "./ai-writing-assistant-dialog";

const AiWritingAssistantFab = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={t("modules.dilemmas.ai_assistant.button_label")}
        className="fixed bottom-6 hover:scale-105 right-6 z-30 p-4 px-5 flex cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-full bg-primary text-white shadow-lg transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      >
        <Sparkles className="size-5 text-white" />
        <span className="font-medium">
          {t("modules.dilemmas.ai_assistant.button_label")}
        </span>
      </button>
      <AiWritingAssistantDialog open={open} onOpenChange={setOpen} />
    </>
  );
};

export default AiWritingAssistantFab;
